import ReadOnlyRecipientViewState from 'owa-readonly-recipient-well/lib/store/schema/ReadOnlyRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';

export default function mergeReadWriteRecipientWellIntoReadOnly(
    readWriteRecipientWell: RecipientWellWithFindControlViewState,
    readOnlyRecipientArray: ReadOnlyRecipientViewState[]
) {
    if (readWriteRecipientWell && readWriteRecipientWell.recipients) {
        for (const recipient of readWriteRecipientWell.recipients) {
            readOnlyRecipientArray.push({ email: recipient.persona.EmailAddress });
        }
    }
}
